import { render, staticRenderFns } from "./WorkingPoints.vue?vue&type=template&id=2dc811ae&scoped=true&"
import script from "./WorkingPoints.vue?vue&type=script&lang=js&"
export * from "./WorkingPoints.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/multiselect.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=2dc811ae&scoped=true&lang=css&"
import style3 from "./WorkingPoints.vue?vue&type=style&index=3&id=2dc811ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc811ae",
  null
  
)

export default component.exports